<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    outlined
    dense
    @change="$emit('input', model)"
    :label="label"
    :rules="rules"
    item-text="name"
    item-value="value"
    return-object
  >
    <template v-slot:item="data">
      <template v-if="isObject(data)">
        <v-list-item-avatar>
          <ImageView :src="data.item.src" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { FIELD } from "../assets/js/rules";
import ImageView from "./ImageView.vue";
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    required: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Provider",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    ImageView,
  },
  data() {
    return {
      model: "",
    };
  },
  computed: {
    rules() {
      return this.required ? FIELD : [];
    },
  },
  methods: {
    isObject({ item }) {
      return item instanceof Object;
    },
  },
  mounted() {
    this.model = this.value;
  },
};
</script>

<style>
</style>